// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteExemptionMutationVariables = Types.Exact<{
  deleteLifetimeExclusionEventId: Types.Scalars['ID']['input'];
  deleteLoggedTransferId: Types.Scalars['ID']['input'];
  shouldDeleteTransfer: Types.Scalars['Boolean']['input'];
}>;


export type DeleteExemptionMutation = { __typename?: 'Mutation', deleteLifetimeExclusionEvent: string, deleteLoggedTransfer?: string };

export const Operations = {
  Mutation: {
    DeleteExemption: 'DeleteExemption' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteExemptionDocument = gql`
    mutation DeleteExemption($deleteLifetimeExclusionEventId: ID!, $deleteLoggedTransferId: ID!, $shouldDeleteTransfer: Boolean!) {
  deleteLifetimeExclusionEvent(id: $deleteLifetimeExclusionEventId)
  deleteLoggedTransfer(id: $deleteLoggedTransferId) @include(if: $shouldDeleteTransfer)
}
    `;
export type DeleteExemptionMutationFn = Apollo.MutationFunction<DeleteExemptionMutation, DeleteExemptionMutationVariables>;

/**
 * __useDeleteExemptionMutation__
 *
 * To run a mutation, you first call `useDeleteExemptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExemptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExemptionMutation, { data, loading, error }] = useDeleteExemptionMutation({
 *   variables: {
 *      deleteLifetimeExclusionEventId: // value for 'deleteLifetimeExclusionEventId'
 *      deleteLoggedTransferId: // value for 'deleteLoggedTransferId'
 *      shouldDeleteTransfer: // value for 'shouldDeleteTransfer'
 *   },
 * });
 */
export function useDeleteExemptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExemptionMutation, DeleteExemptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExemptionMutation, DeleteExemptionMutationVariables>(DeleteExemptionDocument, options);
      }
export type DeleteExemptionMutationHookResult = ReturnType<typeof useDeleteExemptionMutation>;
export type DeleteExemptionMutationResult = Apollo.MutationResult<DeleteExemptionMutation>;
export type DeleteExemptionMutationOptions = Apollo.BaseMutationOptions<DeleteExemptionMutation, DeleteExemptionMutationVariables>;